module.exports = __webpack_public_path__ + "static/media/Email.b474e12c.svg";